import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-face-3",
  "use": "foquz-icon-rating-face-3-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol viewBox=\"0 0 11 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-rating-face-3\"><path d=\"M9 9H2\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" /><circle cx=\"1.5\" cy=\"1.5\" r=\"1.5\" fill=\"#fff\" /><circle cx=\"9.5\" cy=\"1.5\" r=\"1.5\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol